import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analyticsService } from "@/session/infra/observability/analyticsService";
import { initLogMetrics } from "@akina/presentation";

export function useInitializeAnalytics() {
  const location = useLocation();

  useEffect(() => {
    initLogMetrics().catch((error) => {
      console.error(error);
    });
  }, []);

  useEffect(() => {
    if (location.pathname) {
      analyticsService.page({ path: location.pathname });
    }
  }, [location.pathname]);
}
